import { Switch } from 'antd';

function ToggleSwitch({
  onClick = () => {},
  checked = false,
  checkedChildren = false,
  unCheckedChildren = false,
  loading = false,
  disabled = false,
  tabIndex,
  onChange,
}) {
  return (
    <Switch
      className={`toggle-switch-container ${checked ? 'background-success' : 'background-danger'}`}
      onClick={onClick}
      checked={checked}
      disabled={disabled}
      checkedChildren={checkedChildren}
      unCheckedChildren={unCheckedChildren}
      loading={loading}
      tabIndex={tabIndex}
      onChange={onChange}
    />
  );
}

export default ToggleSwitch;
